var render = function render(){var _vm=this,_c=_vm._self._c;return _c('configure-item',{attrs:{"label":_vm.label}},[_c('el-input',_vm._b({attrs:{"size":"small"},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'el-input',_vm.mOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }